import { Component, OnInit, Input } from '@angular/core';
import { DadosAcessoService } from '../../../dadosAcesso.service'

declare var jquery:any;
declare var $ :any;

@Component({
  selector: 'app-menu',
  templateUrl: './menu.component.html',
  styleUrls: ['./menu.component.css']
})
export class MenuComponent implements OnInit {

  public iniciais: string = sessionStorage.getItem('nome_pessoa')
  public usuario: string = sessionStorage.getItem('fantasia_nome')
  public mostrarItem: boolean
  public mostrarCadOper: boolean
  public LinkChat: string

  constructor(private dadosAcesso: DadosAcessoService) {
    if(sessionStorage.getItem('ExibirBotaoEditar') === 'true'){
      this.mostrarItem = true
    }
    else{
      this.mostrarItem = false
    }
    if(sessionStorage.getItem('exibirCadOper')=== 'true'){
      this.mostrarCadOper = true;
    }
    else{
      this.mostrarCadOper = false
    }


    if(sessionStorage.getItem('isNotCacau') === 'true'){
      this.LinkChat = "https://rcky.movidesk.com/kb"
    }else{

      this.LinkChat = "https://rckycs.movidesk.com/kb"
    }

  }


  ngOnInit() {

    $(function(){
      var navMain = $("#navbarNavDropdown");

      navMain.on("click", ".botao", null, function(){
        navMain.collapse('hide');
      });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/shared/menu/menu.component.ts